import * as api from "@/api/i18n";

let dictionary: Record<string, string> = {};
let loader: Promise<void> | null = null;

export const i18n = {
  /**
   * 确保语言包已加载 (由后端中间件自动识别语言)
   */
  async loaded(): Promise<void> {
    if (Object.keys(dictionary).length > 0) {
      return;
    }

    if (loader) {
      return loader;
    }

    loader = api
      .locale()
      .then((data) => {
        dictionary = data;
      })
      .catch((error) => {
        console.error("[i18n] Failed to load translations:", error);
      });

    return loader;
  },

  /**
   * 翻译函数 (同步)
   * @param key 键名
   */
  t(key: string): string {
    return dictionary[key] || key;
  },
};

// 挂载到 window 方便 Alpine.js 模板直接使用
(window as any).t = (key: string) => i18n.t(key);
